// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2LFYz","choiceBoxes":"toolbarselects_choiceBoxes__3A6EW","simpleField":"toolbarselects_simpleField__2qFFa"};